import { render, staticRenderFns } from "./NotFollowUp.vue?vue&type=template&id=fbce2aa4&"
import script from "./NotFollowUp.vue?vue&type=script&lang=js&"
export * from "./NotFollowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports